/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TemplateCreateRequest } from '../../models/template-create-request';
import { TemplateResponse } from '../../models/template-response';

export interface TemplateUpdate$Params {
  'Active-Tenant-Identifier': string;
  templateType: 'opts-config' | 'tender-config' | 'order-charge-limits' | 'pos-status-notifications';
  templateId: string;
      body: TemplateCreateRequest
}

export function templateUpdate(http: HttpClient, rootUrl: string, params: TemplateUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<TemplateResponse>> {
  const rb = new RequestBuilder(rootUrl, templateUpdate.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('templateType', params.templateType, {});
    rb.path('templateId', params.templateId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TemplateResponse>;
    })
  );
}

templateUpdate.PATH = '/ordering/templates/{templateType}/{templateId}';
